
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import './Footer.css';

export default function Footer() {
  return (
    <>
     <footer className="footer">
  <div className="footer-container">
    <div className="footer-column">
      <h3>Quick Links</h3>
      <ul>
        <li><Link to="/">Home</Link></li>
        <li><Link to="/About">About Us</Link></li>
        <li><Link to="/Contact">Contact</Link></li>
      </ul>
    </div>
    <div className="footer-column">
      <h3>Service Links</h3>
      <ul>
        <li><Link to="/House">House</Link></li>
        <li><Link to="/Land">Land</Link></li>
        <li><Link to="/Office">Office</Link></li>
        <li><Link to="/Shop">Shop</Link></li>
        <li><Link to="/Insurance">Insurance</Link></li>
      </ul>
    </div>
    <div className="footer-column">
    <h3 style={{ color: "YELLOW", fontFamily: "Arial Black, sans-serif", textDecoration: "underline", fontSize: "18px" }}>
    APPOLLO AGENCY
</h3>



      <h3>Contact</h3>
      <ul>
        <p>Head Office:</p>
        <li>13.A, Sudhanandha Bharathi St., </li>
        <li>East Tambaram,Chennai-600059.</li>
        <li>Phone: +919884226561</li>
        <p>Branch Office:</p>
        <li>306/16, Mudichur Main Road,</li>
        <li>Mannivakam,Chennai-600048.</li>
        <li>Phone: +919841584115</li>
      </ul>
    </div>
    <div className="footer-column">
      <h3>Our Location</h3>
      <div className="map-container">
        <iframe title="Chennai"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d248755.92960945363!2d79.89748266258087!3d13.047673788603051!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5265ea4f7d3361%3A0x6e61a70b6863d433!2sChennai%2C%20Tamil%20Nadu%2C%20India!5e0!3m2!1sen!2sus!4v1730960735029!5m2!1sen!2sus"
          width="100%"
          height="150"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  </div>
  <div className="footer-bottom">
    <p>© 2024 Appollo Agency. <Link to="/PrivacyPolicy">Privacy Policy</Link> | <Link to="/TermsConditions">Terms & Conditions</Link></p>
    <p><Link to='/refundpolicy'>Refund Policy</Link></p>
    <p>"Built to inspire by SEMMS Solution – Elevating Your Digital Journey! <a href="https://semmssolutions.com/">www.semmssoltuions.com</a></p>
  </div>
</footer>

    </>
  );
}
